/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Geography14Inputs */

const en__field_enum_study_geography14 = /** @type {(inputs: _Field_Enum_Study_Geography14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

const de__field_enum_study_geography14 = /** @type {(inputs: _Field_Enum_Study_Geography14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geographie`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {_Field_Enum_Study_Geography14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_geography14 = /** @type {((inputs?: _Field_Enum_Study_Geography14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Geography14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_geography14(inputs)
	return de__field_enum_study_geography14(inputs)
});
export { _field_enum_study_geography14 as "_field_enum_STUDY_GEOGRAPHY" }